const t = "_wrapper_k57yt_1", o = "_dot_k57yt_11", p = {
  wrapper: t,
  dot: o
};
export {
  p as default,
  o as dot,
  t as wrapper
};
